// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/checkmarkcircle-filled-brand.svg';

export const CheckmarkCircleFilledBrand = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
